module.exports = __webpack_public_path__ + "static/media/trash_can_black.a807f727.svg";